import { Navigate, useLocation } from 'react-router-dom';
import { authService } from 'api/services';

// ==============================|| PROTECTED ROUTE ||============================== //

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    // 로그인 페이지로 리다이렉트, 원래 가려던 경로 저장
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
